import {
  Building07,
  CoinsStacked01,
  GraduationHat01,
  Heart,
  HeartHand,
  MusicNote01,
  ShoppingCart01,
  Ticket01,
  Users01,
} from "@opendate-app/setlist";

export const FAMILIES = [
  { key: "attendance", label: "Attendance", icon: Users01, badge: "blue-light", blurb: "How often fans attend events", subcategories: [
    { key: "frequency", label: "Frequency" },
    { key: "recency", label: "Recency" },
  ] },
  { key: "value", label: "Value", icon: CoinsStacked01, badge: "success", blurb: "Economic value across tickets and donations", subcategories: [] },
  { key: "giving", label: "Giving", icon: Heart, badge: "pink", blurb: "Philanthropic behavior", subcategories: [
    { key: "top_donors", label: "Top Donors" },
    { key: "lifecycle", label: "Lifecycle" },
    { key: "recurring", label: "Recurring" },
    { key: "engagement", label: "Engagement" },
    { key: "retention", label: "Retention" },
    { key: "trends", label: "Trends" },
    { key: "campaigns", label: "Campaigns" },
    { key: "cross_product", label: "Cross Product" },
  ] },
  { key: "preferences", label: "Genre Preferences", icon: MusicNote01, badge: "purple", blurb: "Music and event interests, from artist tags", subcategories: [] },
  { key: "buying", label: "Buying Behavior", icon: ShoppingCart01, badge: "orange", blurb: "How customers purchase", subcategories: [] },
  { key: "engagement", label: "Engagement", icon: HeartHand, badge: "gray-blue", blurb: "Relationships across products", subcategories: [] },
  { key: "classes", label: "Classes", icon: GraduationHat01, badge: "indigo", blurb: "Class registration behavior", subcategories: [] },
  { key: "pass_holders", label: "Pass Holders", icon: Ticket01, badge: "brand", blurb: "Season Pass and pack buyers", subcategories: [] },
  { key: "venue", label: "Venue Experience", icon: Building07, badge: "warning", blurb: "Revenue beyond tickets", subcategories: [] },
];
